import * as React from 'react'

import { XIcon } from 'lucide-react'
import { observer } from 'mobx-react'

import Localization from '~/client/src/shared/localization/LocalizationManager'

interface IProps {
  children: React.ReactNode
  onClose?: () => void
}

@observer
export default class SmartFormImportCard extends React.Component<IProps> {
  public render() {
    const { children, onClose } = this.props
    return (
      <div className="tw:flex tw:flex-col no-outline-container tw:bg-background!">
        <div className="tw:flex tw:items-center tw:justify-between tw:mb-4 tw:border-0 tw:border-b tw:border-solid tw:border-border tw:p-2.5">
          {onClose && (
            <button
              title={Localization.translator.close}
              type="button"
              className="tw:border-none tw:bg-transparent tw:cursor-pointer tw:grow-0 tw:[&_svg]:size-4"
              onClick={onClose}
            >
              <XIcon />
            </button>
          )}
          <h3 className="tw:m-0 tw:text-title-md tw:capitalize tw:text-center tw:flex-1">
            {Localization.translator.smartFormImport}
          </h3>
        </div>
        {children}
      </div>
    )
  }
}
